<div class="row mt-5">
  <div class="col-md-12 text-center" style="font-size:1.8em; color:red; font-weight:bold">
   Online Claims Filing Has Been Disabled
  </div>
</div>
